import React from 'react';

import {SvgProps} from '../../helpers/type';

const Arrow = ({className}: SvgProps): JSX.Element => {
    return (
        <svg width="21px" height="15px" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M0.292893 6.79289C-0.0976314 7.18342 -0.0976315 7.81658 0.292892 8.2071L6.65685 14.5711C7.04738 14.9616 7.68054 14.9616 8.07107 14.5711C8.46159 14.1805 8.46159 13.5474 8.07107 13.1569L2.41421 7.5L8.07107 1.84314C8.46159 1.45262 8.46159 0.819455 8.07107 0.428931C7.68054 0.0384066 7.04738 0.0384066 6.65686 0.428931L0.292893 6.79289ZM21 6.5L1 6.5L1 8.5L21 8.5L21 6.5Z"
                fill="#174943"
            />
        </svg>
    );
};

export default Arrow;
